// extracted by mini-css-extract-plugin
module.exports = {"prompt":"DirectToAppPreinterviewForm_prompt__oRgl7","wrapper":"DirectToAppPreinterviewForm_wrapper__i2clt","inputWrapper":"DirectToAppPreinterviewForm_inputWrapper__uTCv1"};